<template style="height: 100%;width:100%;">
	<div class="token-stat-page"
		style="height: 100%;width:100%;display: flex;flex-direction: column;gap: 12px;box-sizing: border-box;padding:10px;">
		<!-- 筛选栏 -->
		<div>
			<el-form :model="form" inline label-width="80px">
				<el-form-item label="学校" v-if="isAdmin">
					<el-select v-model="form.schoolId" placeholder="请选择学校">
						<el-option v-for="item in schoolList" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-form-item>

				<el-form-item label="">
					<el-select v-model="semesterId" placeholder="请选择学期" @change="forSemester">
						<el-option v-for="item in semesterList" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="起始日期"
						end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="rangePickerOption"
						@change="forDate" style="width: 260px;" :clearable="false"></el-date-picker>
				</el-form-item>
				<el-form-item label="">
					<el-select v-model="grade" placeholder="请选择年级" @change="forGrades">
						<el-option v-for="item in gradeList" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>
				<el-form-item label="">
					<el-select v-model="classId" placeholder="请选择班级" @change="forclass">
						<el-option v-for="item in classList" :key="item.value" :label="item.label"
							:value="item.value" />
					</el-select>
				</el-form-item>
			</el-form>
		</div>

		<!-- 表格容器：取消height=100%，让表格自适应，分页在底部 -->
		<div style="flex: 1; min-height: 0; width:100%;overflow: auto;">
			<el-table :data="tableData" border stripe>
				<el-table-column label="学生姓名" prop="studentName" width="120" />
				<el-table-column label="班级" prop="className" width="100">
					<template slot-scope="scope">
						{{scope.row.className}}
					</template>
				</el-table-column>
				<el-table-column label="年级" prop="gradeId" width="80">
					<template slot-scope="scope">
						{{(scope.row.gradeName)}}
					</template>
				</el-table-column>
				<el-table-column label="对话输入Token" prop="chatInput" />
				<el-table-column label="对话输出Token" prop="chatOutput" />
				<el-table-column label="对话总Token" prop="chatTotal" />
				<el-table-column label="作品输入Token" prop="workInput" />
				<el-table-column label="作品输出Token" prop="workOutput" />
				<el-table-column label="作品总Token" prop="workTotal" />
				<el-table-column label="总输入" prop="totalInput" />
				<el-table-column label="总输出" prop="totalOutput" />
				<el-table-column label="全部合计" prop="allTokenTotal" />
			</el-table>
		</div>

		<!-- 分页组件 -->
		<div style="display:flex;justify-content:flex-end;align-items:center;padding-top:6px;">
			<el-pagination background :current-page="pageNum" :page-size="pageSize" :total="total"
				layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange"></el-pagination>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				form: {
					schoolId: null
				},
				semesterId: null,
				// 替换原来 startDate、endDate
				dateRange: [],
				schoolList: [],
				tableData: [],
				login: null,
				semesterList: [],
				semStartTs: null,
				semEndTs: null,
				// 统一日期范围禁用规则
				rangePickerOption: {
					disabledDate: time => this.disabledRangeDate(time)
				},

				total: 0,
				isAdmin: false,
				pageSize: 10,
				pageNum: 1,
				semesterArr: {},
				oldYear: null,
				grade: -1,
				classId: 0,
				gradeList: [],
				classList: []
			}
		},
		created() {
			// this.forGradeList()
			this.fetchSchool()
		},
		methods: {
			forGrades() {
				this.pageNum = 1
				this.classId = 0
				this.classList = this.gradeList.find(v => v.value == this.grade)?.classList
				this.handleQuery()
			},
			forclass() {
				this.pageNum = 1
				this.handleQuery()
			},
			async togradeList() {
				let classList = localStorage.getItem('classList') || ''
				let gradeList = [{
					value: -1,
					label: "全部年级",
					classList: [{
						value: 0,
						label: '全部班级',
					}]
				}]
				try {
					let Lists = JSON.parse(classList)
					Lists?.map(v => {
						if (v.isRole) {
							let classL = []

							v.classList?.map(_v => {

								if (_v.isRole) {
									var name = `${_v.classAlias}`

									if (_v.areaName) {
										name = `${name}(${_v.areaName})`
									}

									classL.push({
										value: _v.id,
										label: name,
										areaName: _v.areaName
									})
								}

							})
							let arr = {
								value: v.gradeId,
								label: v.gradeName,
								classList: classL
							}

							gradeList.push({
								...arr
							})
						}
					})
					this.classList = gradeList.find(v => v.value == -1)?.classList || []

					this.gradeList = gradeList

				} catch (error) {
					this.gradeList = gradeList
				} finally {}
			},
			// forGradeList(){
			//  this.gradeList=forGradeList()
			// },
			forGrade(val) {
				let name = '--'
				let list = ['一', '二', "三", '四', "五", "六", "七", "八", '九', "高一", "高二", "高三"]
				if (val) {
					name = list[val] || '--'
				}
				return name
			},
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			async fetchSchool() {
				this.loginOpen('初始化中...')
				await this.togradeList()
				if (localStorage.getItem('userType') == 1) {
					this.isAdmin = true
				}
				if (localStorage.getItem('userType') == 2) {
					this.form.schoolId = localStorage.getItem('orgId')
					var name = localStorage.getItem('orgName')
					this.schoolList = [{
						id: this.form.schoolId,
						name: name
					}]
				}
				if (localStorage.getItem('semester')) {
					let list = JSON.parse(localStorage.getItem('semester'))
					this.semesterList = list?.map(v => {
						v.label = `${v.year}-${Number(v.year) + 1}学年${v.term == 1 ? "第一学期" : "第二学期"}`
						v.value = v.id
						return {
							...v
						}
					}).filter(v=>v.status!=0)
					this.semesterId = this.semesterList?.find(v => v.status == 1).value || null
					this.oldYear = this.semesterList?.find(v => v.status == 1).year || null
					this.noLogin()
					this.forSemester()
				}
			},
			forSemester(id) {
				const arr = this.semesterList.find(v => v.value === this.semesterId)
				this.semesterArr = arr
				if (!arr) return
				this.pageNum = 1
				let time = new Date();
				let todayZero = new Date(time);
				todayZero.setHours(0, 0, 0, 0);
				let prevDayEndTs = todayZero.getTime() - 1;
				// 今天 23:59:59 时间戳
				let todayEndTs = todayZero.getTime() + 86399 * 1000;

				this.semStartTs = arr.startTime
				this.semEndTs = arr.endTime
				let semEndTs = arr.endTime
				let semStartTs = arr.startTime

				if (arr.endTime >= prevDayEndTs) {
					semEndTs = prevDayEndTs
				}
				// 关键：起始大于等于结束，修正结束为今天23:59:59
				if (semStartTs >= semEndTs) {
					semEndTs = todayEndTs
				}
				// 自动赋值日期范围 [开始日期,结束日期]
				this.dateRange = [this.tsToYmd(semStartTs), this.tsToYmd(semEndTs)]
				this.grade = -1
				this.forGrades()

				this.handleQuery()
			},
			handleCurrentChange(page) {
				this.pageNum = page
				this.handleQuery()
			},
			forDate() {
				this.pageNum = 1
				this.handleQuery()
			},
			tsToYmd(ts) {
				if (!ts) return ''
				const d = new Date(ts)
				const year = d.getFullYear()
				const month = String(d.getMonth() + 1).padStart(2, '0')
				const day = String(d.getDate()).padStart(2, '0')
				return `${year}-${month}-${day}`
			},
			totime(val, type) {
				var time = new Date(val).getTime()
				if (type == 2) {
					time = time + 16 * 60 * 60 * 1000
				} else {
					time = time - 8 * 60 * 60 * 1000
				}
				return time
			},
			// 日期范围选择器禁用规则
			disabledRangeDate(time) {
				if (!this.semStartTs || !this.semEndTs) return false
				const dayTs = time.getTime()
				return dayTs < this.semStartTs || dayTs > this.semEndTs
			},
			async handleQuery() {
				if (!this.form.schoolId || !this.dateRange || this.dateRange.length !== 2) {
					this.$message.warning('请完善筛选条件')
					return
				}
				const [startDay, endDay] = this.dateRange
				const selectStartTs = new Date(startDay).getTime()
				const selectEndTs = new Date(endDay).getTime()

				// 校验选中日期不能超出学期区间
				if (selectStartTs < this.semStartTs || selectEndTs > this.semEndTs) {
					this.$message.warning(
						`日期必须在学期范围：${this.tsToYmd(this.semStartTs)} ~ ${this.tsToYmd(this.semEndTs)}`)
					return
				}
				if (selectStartTs > selectEndTs) {
					this.$message.warning('起始时间不能晚于结束时间')
					return
				}

				this.loginOpen('数据查询中...')
				let grade = this.grade == -1 ? null : (Number(this.grade) - Number(this.oldYear) + Number(this
					.semesterArr.year))
				try {
					const res = await this.API.get(this.API.fileurl.getStudentDateMessage, {
						schoolId: this.form.schoolId,
						statDate: startDay,
						endDate: endDay,
						term: this.semesterArr.term,
						year: this.semesterArr.year,
						pageNum: this.pageNum,
						grade: grade,
						classId: this.classId == 0 ? null : this.classId,
						pageSize: this.pageSize,
					})
					let list = res?.data?.data?.records || []
					this.tableData = list?.map(v => {
						v.chatInput = 0
						v.chatOutput = 0
						v.workInput = 0
						v.workOutput = 0
						var name = v.areaName ? `${v.className}(${v.areaName})` : v.className
						v.className = name
						v.tokenList.map(a => {
							if (a.source == 1) {
								v.chatInput = v.chatInput + Number(a.totalRequestToken)
								v.chatOutput = v.chatOutput + Number(a.totalConsumeToken)
							}
							if (a.source == 2) {
								v.workInput = v.workInput + Number(a.totalRequestToken)
								v.workOutput = v.workOutput + Number(a.totalConsumeToken)
							}
						})
						v.chatTotal = v.chatInput + v.chatOutput
						v.workTotal = v.workInput + v.workOutput
						v.totalInput = v.chatInput + v.workInput
						v.totalOutput = v.chatOutput + v.workOutput
						v.allTokenTotal = v.chatTotal + v.workTotal
						return {
							...v
						}
					})
					this.total = res?.data?.data?.total || 0
				} catch (error) {

				} finally {
					this.noLogin()
				}
			},
			handleReset() {
				this.form.schoolId = null
				this.dateRange = []
				this.tableData = []
			}
		}
	}
</script>